import { CollectionMethod } from '../retail-customer-configuration';
import { CollectionMethod as ApiCollectionMethod } from '@vendasta/billing';

export function convertFromApiCollectionMethod(s: ApiCollectionMethod): CollectionMethod {
  switch (s) {
    case ApiCollectionMethod.COLLECTION_METHOD_INVALID:
      return CollectionMethod.UNSET;
    case ApiCollectionMethod.COLLECTION_METHOD_MANUAL:
      return CollectionMethod.MANUAL_COLLECTION;
    case ApiCollectionMethod.COLLECTION_METHOD_EMAIL:
      return CollectionMethod.SEND_EMAIL;
    case ApiCollectionMethod.COLLECTION_METHOD_CHARGE_AUTOMATICALLY:
      return CollectionMethod.CHARGE_AUTOMATICALLY;
    default:
      return CollectionMethod.UNSET;
  }
}

export function convertToApiCollectionMethod(s: CollectionMethod): ApiCollectionMethod {
  switch (s) {
    case CollectionMethod.UNSET:
      return ApiCollectionMethod.COLLECTION_METHOD_INVALID;
    case CollectionMethod.MANUAL_COLLECTION:
      return ApiCollectionMethod.COLLECTION_METHOD_MANUAL;
    case CollectionMethod.SEND_EMAIL:
      return ApiCollectionMethod.COLLECTION_METHOD_EMAIL;
    case CollectionMethod.CHARGE_AUTOMATICALLY:
      return ApiCollectionMethod.COLLECTION_METHOD_CHARGE_AUTOMATICALLY;
    default:
      return ApiCollectionMethod.COLLECTION_METHOD_INVALID;
  }
}
